'use client';

import EditableMarkdownV2 from "@/app/features/shared/editable-markdown/EditableMarkdownV2";
import useMarkdownEditScrollLock
    from "@/app/features/shared/editable-markdown/hooks/useMarkdownEditScrollLock";
import { useImpressumEditor } from "@/app/features/sites/impressum/contexts/ImpressumEditorContext";
import ImpressumRootFrame from "@/app/features/sites/impressum/ui/shared/ImpressumFrames";

export default function ImpressumEditable() {
    const { editable, updateEditable, errorForField } = useImpressumEditor();
    const { isMarkdownEditing, onMarkdownEditingChange } = useMarkdownEditScrollLock();
    const contentError = errorForField?.('content') || undefined;

    return (
        <ImpressumRootFrame constrainToViewport={isMarkdownEditing}>
            <EditableMarkdownV2
                label="Inhalt"
                ariaLabel="Impressum bearbeiten"
                required
                value={editable?.content ?? ''}
                onChange={(content) => updateEditable({ content })}
                onEditingChange={onMarkdownEditingChange}
                error={Boolean(contentError)}
                helperText={contentError}
            />
        </ImpressumRootFrame>
    );
}
